<div class="data-consent-revoke">
  <div class="data-consent-revoke__container">
    <h1 class="data-consent-revoke__title">Revoke or modify your consent</h1>
    <a class="data-consent-revoke__link" (click)="openCookieHubPreferences()">
      Click here to review and modify your cookie preferences
    </a>
  </div>
</div>
